import React, { useEffect, useState } from "react";
import { Form, Nav, Tab } from "react-bootstrap";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import MySearch from "../Common/MySearch";
import { useGetTagsQuery } from "../store/slices/settingsSlice";

export default function SystemSolutionsFilter({ filters, setFilters }) {
  const [search, setSearch] = useState("");
  useEffect(() => {
    const first = setTimeout(() => {
      setFilters({ ...filters, search, offset: 0 });
    }, 500);

    return () => {
      clearTimeout(first);
    };
  }, [search]);

  const tabs = [
    {
      eventKey: "my-solutions",
      heading: "My Solutions",
      subheading: "Select a pre-built Solution to suit your requirement .",
    },
    {
      eventKey: "system-solutions",
      heading: "System Solutions",
      subheading: "Browse and manage your components.",
    },
  ];

  const categories =
    useGetTagsQuery({ kind: "category", limit: 1000 }).data?.data || [];
  const industryTypes =
    useGetTagsQuery({ kind: "industry", limit: 1000 }).data?.data || [];

  return (
    <div>
      <div className=" bg-colored-reverse p-3 m-0 rounded-3 mb-3">
        <div className="row justify-content-between align-items-center">
          {/* <div className="col-2">
          <span className="fw-bold p-2 text-white mb-2">Components:</span>

          <Form.Select
            aria-label="components-select"
            onChange={(e) => {
              setOrderBy(e.target.value);
            }}
            value={orderBy}
          >
            <option value="workflow-project">Workflow project</option>
            <option value="api">API</option>
            <option value="monitor">Monitor</option>
          </Form.Select>
        </div> */}
          <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Category:</span>
            <Input
              placeholder="Showing all category types"
              inputType="select"
              isMulti
              isValidNewOption={(o) => o}
              value={filters.category || []}
              isClearable
              onChange={(v) => {
                setFilters({ ...filters, category: v, offset: 0 });
              }}
              options={[...categories.map((c) => ({ value: c, label: c }))]}
            />
            {/* <Form.Select
              aria-label="status-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  category: e.target.value,
                  offset: 0,
                });
              }}
              value={filters.category}
            >
              <option value="">all</option>
              {categories.map((c) => (
                <option value={c} key={c}>
                  {c}
                </option>
              ))}
            </Form.Select> */}
          </div>
          <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Solution Type:</span>

            <Form.Select
              aria-label="kind-select"
              onChange={(e) => {
                setFilters({ ...filters, kind: e.target.value, offset: 0 });
              }}
              value={filters.kind}
            >
              <option value="standard">standard</option>
              <option value="events">events</option>
              <option value="">all</option>
            </Form.Select>
          </div>
          <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">
              Business Use-Case:
            </span>

            <Form.Select
              aria-label="deployed-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  deployed: e.target.value,
                  offset: 0,
                });
              }}
              value={filters.deployed}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
              <option value="">all</option>
            </Form.Select>
          </div>
          {/* <div className="col-4">
            <span className="fw-bold p-2 text-white mb-2 ">Purchased:</span>

            <Form.Select
              aria-label="purchased-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  purchased: e.target.value,
                  offset: 0,
                });
              }}
              value={filters.purchased}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
              <option value="">all</option>
            </Form.Select>
          </div> */}
        </div>
        <div className="row justify-content-start align-items-center">
          <div className="col-4 mt-3">
            <span className="fw-bold p-2 text-white mb-2">Industry types:</span>

            <Input
              placeholder="Showing all industry types"
              inputType="select"
              isMulti
              isValidNewOption={(o) => o}
              value={filters.industry || []}
              isClearable
              onChange={(v) => {
                setFilters({ ...filters, industry: v, offset: 0 });
              }}
              options={[...industryTypes.map((i) => ({ value: i, label: i }))]}
            />
          </div>

          <div className="col-4 mt-3 ">
            <div className="fw-bold  text-white">Search:</div>
            <div className="">
              <MySearch
                placeholder="Search by name, reference, description..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
